import isObject from "./isObject.util.js";
import isFunction from "../function/isFunction.util.js";
const augmentKey = (key, keyName, excludeKey, innerObj) => {
    if (excludeKey && innerObj?.[excludeKey])
        return false;
    if (Array.isArray(keyName)) {
        return keyName.includes(key);
    }
    else {
        return key === keyName;
    }
};
const augmentFunctionKeyUtil = (obj, { augmentAction, keyName, excludeKey }) => {
    if (!obj)
        return obj;
    const recursiveMap = (innerObj) => Object.keys(innerObj).reduce((acc, key) => {
        const value = innerObj[key];
        if (augmentKey(key, keyName, excludeKey, innerObj) && isFunction(value)) {
            acc[key] = (...args) => {
                augmentAction(innerObj);
                value(args);
            };
        }
        else if (Array.isArray(value)) {
            acc[key] = value.map(recursiveMap);
        }
        else if (isObject(value)) {
            acc[key] = recursiveMap(value);
        }
        else {
            acc[key] = value;
        }
        return acc;
    }, {});
    return recursiveMap(obj);
};
export default augmentFunctionKeyUtil;
